import { useMemo as e } from "react";
//#region src/utils/groupMessages.ts
var t = 300 * 1e3;
function n(e) {
	let t = new Date(e);
	return `${t.getFullYear()}-${t.getMonth()}-${t.getDate()}`;
}
function r(e) {
	if (e.length === 0) return [];
	let r = [], i = n(e[0].created_at), a = [], o = {
		senderId: e[0].sender_id,
		messages: [e[0]]
	};
	for (let s = 1; s < e.length; s++) {
		let c = e[s], l = n(c.created_at), u = e[s - 1], d = new Date(c.created_at).getTime() - new Date(u.created_at).getTime(), f = c.sender_id === o.senderId, p = d <= t;
		if (l !== i) {
			a.push(o), r.push({
				day: i,
				groups: a
			}), i = l, a = [], o = {
				senderId: c.sender_id,
				messages: [c]
			};
			continue;
		}
		f && p ? o.messages.push(c) : (a.push(o), o = {
			senderId: c.sender_id,
			messages: [c]
		});
	}
	return a.push(o), r.push({
		day: i,
		groups: a
	}), r;
}
function i(t) {
	return e(() => r(t), [t]);
}
//#endregion
export { t as GROUPING_WINDOW_MS, n as dayKey, r as groupMessages, i as useGroupMessages };
